import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackHeaderPinFilterClick } from './tracking';
import { setChatbotMenu } from '../../actions/chatbot/actions';
import { ChatHeaderPinFilter } from '../../components/ChatHeader/ChatHeaderPinFilter';
import { chatbotSelector } from '../../selectors';

export const ChatHeaderPinFilterContainer: React.FC = () => {
  const { messageInfoBlock, chatbotMenu } = useSelector(chatbotSelector) || {};
  const dispatch = useDispatch();

  const handleItemClick = React.useCallback(() => {
    trackHeaderPinFilterClick();

    dispatch(setChatbotMenu({ menuIsOpen: !chatbotMenu.menuIsOpen, menuOpenSource: 'pinned_search' }));
  }, [dispatch, chatbotMenu.menuIsOpen]);

  if (!messageInfoBlock) {
    return null;
  }

  return <ChatHeaderPinFilter pinFilter={messageInfoBlock} onClick={handleItemClick} />;
};
